import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setPropertyTypeApiMiddleware = middlewareObject => {
    api = middlewareObject
}

const SYSTAGS = {
    author: {
        name: 'Autor',
        icon: 'fa-user-edit',
        color: 'SkyBlue',
        help: `Pokud nastavíte tuto vlastnost jako autora,
               bude automaticky doplněna dle přihlášeného uživatele a použita v systému.
               Takto nastavenou vlastnost můžete mít pouze jednu.`,
    },
    // deadline: {
    //     name: 'Deadline',
    //     icon: 'fa-bell',
    //     color: 'Orange',
    //     help: `Pokud nastavíte tuto vlastnost jako deadline, bude s ní systém počítat,
    //            zasílat upozornění a zobrazovat ji červeně, pokud je již po stanoveném datu.
    //            Takto nastavenou vlastnost můžete mít pouze jednu.`,
    // },
    startTime: {
        name: 'Začátek',
        icon: 'fa-hourglass-start',
        color: 'LightGreen',
        help: `Označuje datum/čas začátku úkolu.`,
    },
    endTime: {
        name: 'Konec',
        icon: 'fa-hourglass-end',
        color: 'LightPink',
        help: `Označuje datum/čas konce úkolu.`,
    },
    creationTimestamp: {
        name: 'Datum a čas vytvoření',
        icon: 'fa-hourglass-start',
        color: 'Moccasin',
        help: `Do takto označené vlastnosti bude automaticky uloženo datum a čas vytvoření položky.`,
    },
    // duration: {
    //     name: 'Doba trvání',
    //     icon: 'fa-calendar-day',
    //     color: 'SkyBlue',
    //     help: `Délka trvání pro účely kalendáře.`,
    // },
    done: {
        name: 'Hotovo',
        icon: 'fa-check',
        color: 'Turquoise',
        help: `Takto označená vlastnost bude udávat, zda je úkol či projekt hotov (pro automatické filtrování)`,
    },
    entityColor: {
        name: 'Barevné označení',
        icon: 'fa-paint-brush',
        color: 'Lime',
        help: 'Tato vlastnost nebude normálně zobrazena ale použije se pro barevné odlišení jednotlivé entity (projekt/úkol/zdroj)',
    },
    parentTask: {
        name: 'Nadřazený úkol',
        icon: 'fa-indent',
        color: 'Bisque',
        help: 'Takto označená vlastnost se používá pro vytvoření hierarchické struktury mezi úkoly (Funguje pouze pro ukoly)',
    },
    dependentOn: {
        name: 'Závisí na úkolu',
        icon: 'fa-angle-double-right',
        color: 'Beige',
        help: 'Takto označená vlastnost se používá pro vytvoření zavislosti úkolu na úkolu (Funguje pouze pro ukoly)',
    },
    assignee: {
        name: 'Zpracovatel',
        icon: 'fa-user-tag',
        color: 'Magenta',
        help: 'Tomuto zdroji bude úkol přidělen ke zpracování.',
    },
    milestone: {
        name: 'Milník',
        icon: 'fa-bell',
        color: '#FFA500',
        help: 'Datum a/nebo čas kdy má být provedena na projektu nějaká dúležitá akce jako např.: kontrola stavu, rozhodnutí atd.',
    },
    resourceUser: {
        name: 'Uživatel zdroje',
        icon: 'fa-user-tag',
        color: 'MediumAquamarine',
        help: 'Tento tag vytváří vazbu mezi uživatelem systému a zdrojem tak aby bylo možno zobrazit např. moje úkoly',
    },
    entityState: {
        name: 'Stav',
        icon: 'fa-bullseye',
        color: 'Turquoise',
        help: 'Tento tag označuje vlastnost která bude použita pro řešení stavu úkolu, projektu či zdroje.',
    },
    progress: {
        name: 'Progress',
        icon: 'fa-battery-half',
        color: 'DeepSkyBlue',
        help: 'Tento tag přepíná číslo do módu progress bar od "Minimání hodnoty" po "Maximální hodnotu" po krocích nastavených v záložce "Nastavení čísla a jednotky".',
    },
    smbUser: {
        name: 'Uživatelské jméno na sambě',
        icon: 'fa-windows',
        color: 'DodgerBlue',
        help: 'Tento tag propojuje uživatele samby se zdrojem',
    },
}

const DATA_TYPES_SYSTAGS = {
    'LINK_USER': ['author', 'resourceUser'],
    'LINK_PERSON_RESOURCE': ['assignee'],
    'LINK_THING_RESOURCE': ['assignee'],
    'LINK_PLACE_RESOURCE': ['assignee'],
    'DATE_TIME': ['deadline', 'startTime', 'endTime', 'creationTimestamp', 'milestone'],
    'DATE': ['deadline', 'startTime', 'endTime', 'milestone', 'creationTimestamp'],
    'BOOLEAN': ['done'],
    'NUMERIC': ['progress'],
    'COLOR': ['entityColor'],
    'LINK': ['parentTask', 'dependentOn'],
    'ENTITY_STATE': ['entityState'],
    'STATIC_STRING': ['smbUser'],
}

export default () => ({
    state: {
        propertyTypes: [],
        propertyTypesLoading: false,
        parameters: [],
    },
    getters: {
        propertyTypes: state => state.propertyTypes,
        activePropertyTypes: state => _.filter(state.propertyTypes, { 'activeUntil': null }),
        nonActivePropertyTypes: state => _.filter(state.propertyTypes, function(pt) {
            return pt.activeUntil === 0 || pt.activeUntil === null
        }),
        propertyTypeByKey: state => key => _.find(state.propertyTypes, ['key', key]),
        propertyTypeById: state => id => _.find(state.propertyTypes, ['id', id]),
        propertyTypesLoading: state => state.propertyTypesLoading,
        propertyParameters: state => state.parameters,
        systagsByDataType: state => id => {
            return _.chain(DATA_TYPES_SYSTAGS)
                .get(id, [])
                .map(tag => {
                    return {
                        tag,
                        help: _.get(SYSTAGS, `${tag}.help`, ''),
                        name: _.get(SYSTAGS, `${tag}.name`, tag),
                        icon: _.get(SYSTAGS, `${tag}.icon`),
                        color: _.get(SYSTAGS, `${tag}.color`, 'LightSkyBlue'),
                    }
                })
                .value()
        },
        systags: state => SYSTAGS,

    },
    mutations: {
        setPropertyTypes: (state, propertyTypes) => {
            state.propertyTypes = propertyTypes
        },
        setParameters: (state, parameters) => {
            state.parameters = parameters
        },
        addPropertyType: (state, newPropertyType) => {
            state.propertyTypes.push(newPropertyType)
        },
        propertyTypesLoading: (state, propertyTypesLoading) => {
            state.propertyTypesLoading = propertyTypesLoading
        },
    },
    actions: {
        async propertyTypesLoad({ commit }) {
            commit('propertyTypesLoading', true)
            return api.get('/propertyType?depth=2')
                .then(data => {
                    commit('setPropertyTypes', data)
                    return data
                })
                .finally(_ => {
                    commit('propertyTypesLoading', false)
                })
        },
        async updateAllPropertyTypes({ getters }) {
            return Promise.all(_.map(getters.propertyTypes, async pt => api.put(`/propertyType/${pt.id}`, pt)))
        },
        async updatePropertyType({ commit }, data) {
            return api.put(`/propertyType/${data.id}`, data)
                .then(r => {
                    return r
                })
        },
        async createPropertyType({ commit }, data) {
            return api.post('/propertyType', data)
                .then(r => {
                    return r
                })
        },
        async parametersLoad({ commit }) {
            return api.get('/parameter?depth=2')
                .then(data => {
                    commit('setParameters', data)
                    return data
                })
        },
        async updateParameter({ commit }, data) {
            const filteredData = {
                value: _.get(data, 'value'),
            }
            return api.put(`/parameter/${data.id}`, filteredData)
                .then(data => {
                    this.dispatch('parametersLoad')
                })
        },
        async createParameter({ commit }, data) {
            return api.post(`/parameter/`, data)
                .then(data => {
                    this.dispatch('parametersLoad')
                })
        },
    },
})
